import { render, staticRenderFns } from "./ActionList.vue?vue&type=template&id=2a636d19"
import script from "./ActionList.vue?vue&type=script&lang=js"
export * from "./ActionList.vue?vue&type=script&lang=js"
import style0 from "./ActionList.vue?vue&type=style&index=0&id=2a636d19&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports